<template>
  <div class="organization-container">
    <admin-organization v-if="$root.isAdmin || $root.isSystem" />
    <user-organization v-else />
  </div>
</template>

<script>
import AdminOrganization from './Organization'
import UserOrganization from '@/components/dashboard/organizations/user/organization/UserOrganization'

export default {
  name: 'OrganizationContainer',
  components: { AdminOrganization, UserOrganization }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/OrganizationContainer.vue